import React, { useEffect } from 'react';
import styles from './OurProjects.module.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import 'swiper/css';

import NumberCard from '../../components/NumberCard';

import clientsJson from '../../assets/data/clients.json';
import projectsJson from '../../assets/data/projects.json';
import { useTranslation } from 'react-i18next';

const OurProjects = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.title = 'Our Projects - The Records Hub S.A.';
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.titleContainer}>
                <p className={styles.title}>{t('ourProjects.title')}</p>
                <br />
                <div className={styles.numberCards}>
                    <NumberCard
                        symbol='+'
                        number={59}
                        label={t('ourProjects.numberLabel0')}
                        width='150px'
                        padding='14px'
                    />
                    <NumberCard
                        symbol='+'
                        number={33}
                        label={t('ourProjects.numberLabel1')}
                        width='150px'
                        padding='14px'
                    />
                </div>
            </div>
            <div className={styles.carouselContainer}>
                <Swiper
                    className={styles.swiperElement}
                    modules={[Navigation, Pagination, Scrollbar, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={9}
                    speed={1000}
                    loop
                    autoplay={{ delay: 100 }}
                    pagination={{
                        clickable: true
                    }}
                    breakpoints={{
                        0: {
                            // width: 576,
                            slidesPerView: 3,
                            spaceBetween: 10
                        },
                        700: {
                            // width: 768,
                            slidesPerView: 4,
                            spaceBetween: 10
                        },
                        950: {
                            // width: 768,
                            slidesPerView: 9,
                            spaceBetween: 10
                        }
                    }}
                    scrollbar={{ draggable: true }}
                >
                    {clientsJson &&
                        clientsJson.map((client, i) => (
                            <SwiperSlide key={`client_slide_${i}`}>
                                <div className={styles.carouselImgContainer}>
                                    <img className={styles.carouselImg} src={client} alt={client} />
                                </div>
                            </SwiperSlide>
                        ))}
                </Swiper>
            </div>
            <div className={styles.projectsContainer}>
                {projectsJson &&
                    projectsJson.map((project, i) => (
                        <div
                            key={`project_${i}`}
                            className={styles.projectContainer}
                            style={{
                                backgroundColor: i % 2 === 0 ? 'white' : 'rgba(198, 198, 198, 0.2)'
                            }}
                        >
                            {i % 2 === 0 ? (
                                <>
                                    <div className={styles.projectImgContainer}>
                                        <img
                                            className={styles.projectImg}
                                            src={project.img}
                                            alt={project.title[i18n.language]}
                                        />
                                    </div>
                                    <div className={styles.projectDiscriptionContainer}>
                                        <p className={styles.projectTitle}>
                                            {project.title[i18n.language]}
                                        </p>
                                        <p className={styles.projectDiscription}>
                                            {project.discription[i18n.language]}
                                        </p>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={styles.projectDiscriptionContainer}>
                                        <p className={styles.projectTitle}>
                                            {project.title[i18n.language]}
                                        </p>
                                        <p className={styles.projectDiscription}>
                                            {project.discription[i18n.language]}
                                        </p>
                                    </div>
                                    <div className={styles.projectImgContainer}>
                                        <img
                                            className={styles.projectImg}
                                            src={project.img}
                                            alt={project.title[i18n.language]}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default OurProjects;
